import React from 'react';
import Navigation from '../Navigation';
import { CircularProgress, Grid, Typography } from '@mui/material';
import PersonCard from '../PersonCard';
import { useState, useEffect } from 'react';
import { getAllstudents } from '../../repo/firebaseFunctions';

function AllStudents() {

  const [isLoading, setIsLoading] = useState(true);
  const [allStudents, setAllStudents] = useState([]);

  useEffect(() => {
    async function fetchData() {
      // const schoolId = localStorage.getItem('uid') ?? 
      const students = await getAllstudents("001"); 
      setAllStudents(students);
      setIsLoading(false);
    }
    fetchData();
  }, []);


  return (
    <Navigation heading={"All Students"}>
       {isLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '30%' }}>
        <CircularProgress />
      </div>
      ) : (
        <Grid
          style={{ paddingTop: '80px' }}
          container
          rowSpacing={3}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
         {Array.isArray(allStudents) && allStudents.length > 0 ? (
            allStudents.map((student) => (
              <PersonCard
                type= 'student'
                id={student.id}
                name={student.name}
                title={student.courseID}
                subTitle={student.email}
                student = {student}
                
              />
            ))
          ) : (
            <div style={{ display: 'flex', textAlign: 'center' }}>

              <Typography>No students found</Typography>
            </div>
          )}
        </Grid>
      )}
       </Navigation>
  );
}

export default AllStudents;


